// A help guide is either a video (help_video.url = tutorial/X.mp4) or a PDF
// document (help_video.url = tutorial/X.pdf). PDF guides show a download
// button in place of the video player.
export function isPdfGuide(url) {
	return typeof url === 'string' && url.trim().toLowerCase().endsWith('.pdf');
}

// A step title may carry its section: "Section B: Set up portfolio groups | Open Manage Groups".
// The page shows the section as a heading once, with the steps under it. Titles without
// the separator (the video guides) have no section and render as before.
const SECTION_SEPARATOR = ' | ';

export function splitStepTitle(title) {
	if (typeof title !== 'string') return { section: null, title };
	const at = title.indexOf(SECTION_SEPARATOR);
	if (at < 0) return { section: null, title };
	return {
		section: title.slice(0, at).trim() || null,
		title: title.slice(at + SECTION_SEPARATOR.length).trim(),
	};
}

// Step text supports a small Markdown subset, split into blocks here (bold is inline, handled by the page):
//   "1. item" / "1) item" lines -> numbered list    "- item" / "* item" lines -> bullet list
//   a blank line -> new paragraph
// Single line breaks stay inside one paragraph (HTML collapses them), so existing step text renders unchanged.
export function parseStepText(text) {
	if (typeof text !== 'string' || !text) return [];
	const blocks = [];
	let para = null;
	let list = null;
	const flushPara = () => {
		if (para) blocks.push({ type: 'p', text: para.join('\n') });
		para = null;
	};
	const flushList = () => {
		if (list) blocks.push(list);
		list = null;
	};
	for (const line of text.split('\n')) {
		const ordered = line.match(/^\s*\d+[.)]\s+(.*)$/);
		const bullet = !ordered && line.match(/^\s*[-*]\s+(.*)$/);
		if (ordered || bullet) {
			flushPara();
			const type = ordered ? 'ol' : 'ul';
			if (!list || list.type !== type) {
				flushList();
				list = { type, items: [] };
			}
			list.items.push((ordered || bullet)[1]);
		} else if (line.trim() === '') {
			flushPara();
			flushList();
		} else {
			flushList();
			para = para || [];
			para.push(line);
		}
	}
	flushPara();
	flushList();
	return blocks;
}
